// Password prompt for joining a private lobby.
import { useState, type FormEvent } from "react";
import { LOBBY_PASSWORD_MAX, LobbyPasswordSchema } from "@wp/shared";
import { Modal } from "../common/Modal";

export function JoinPrivateDialog({
  lobby,
  onClose,
  onJoin,
}: {
  lobby: { name: string };
  onClose: () => void;
  onJoin: (password: string) => Promise<string | null>;
}) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;
    if (!LobbyPasswordSchema.safeParse(password).success) {
      setError("Enter the lobby password.");
      return;
    }
    setBusy(true);
    setError(null);
    const problem = await onJoin(password);
    setBusy(false);
    if (problem) setError(problem);
  }

  return (
    <Modal title={`Join “${lobby.name}”`} onClose={onClose} testId="join-dialog">
      <form onSubmit={(e) => void submit(e)} className="stack-form" noValidate>
        <label className="field">
          <span>Lobby password</span>
          <input
            data-testid="join-password"
            type="password"
            value={password}
            maxLength={LOBBY_PASSWORD_MAX}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
          />
        </label>
        {error && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}
        <div className="dialog-actions">
          <button type="button" className="btn" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn primary" disabled={busy} data-testid="join-submit">
            {busy ? "Joining…" : "Join"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
